import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';
import Get_Order from "../Sub_Componet/Get_Order";

let source = axios.CancelToken.source();

class Close_order_status extends Component {
    constructor() {
        super();
        var date = new Date();
        this.state = {
            allovehs: [],
            allovehsl: false,
        }
    }

    async componentDidMount() {
        this.get_close_order_status();
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    get_close_order_status = () => {
        let baseurl = myconfig.get_close_order_status;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            allovehs: [],
            allovehsl: false,
            cushow: false,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    allovehs: res.data,
                    allovehsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.allovehsl) {
            retdata = this.state.allovehs.datas.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td><a href={myconfig.redirectoallocation_status+"?order_id="+value.id} target="_blank">More</a></td>
                    <td>{value.orderdate}</td>
                    <td>{value.order_no}</td>
                    <td>{value.companyname}</td>
                    <td>{value.cargo_name}</td>
                    <td>{value.volume}</td>
                    <td>{value.sale_type}</td>
                    <td>{value.type}</td>
                    <td>{value.transport_rate_q}</td>
                    <td>{value.cement_rate_q}</td>
                    <td>{value.cement_cost}</td>
                    <td>{value.stdate}</td>
                    <td>{value.eddate}</td>
                    <td>{value.rr_loc_org}</td>
                    <td>{value.rr_loc_des}</td>
                    <td>{value.total_count}</td>
                    <td>{value.assigned_count}</td>
                    <td>{value.not_assigned}</td>
                    <td>{value.created_at}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }


    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    render() {
        return (
            <>
                <Nav type="close_order_status"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Closed Order</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Closed Order</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="table_search"
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <table className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Action</th>
                                                <th>Order Date</th>
                                                <th>Order #</th>
                                                <th>Company Name</th>
                                                <th>Cargo Name</th>
                                                <th>Volume</th>
                                                <th>Sale Type</th>
                                                <th>Type</th>
                                                <th>Transport Rate</th>
                                                <th>Cement Rate</th>
                                                <th>Cement Cost</th>
                                                <th>Start Date</th>
                                                <th>Closed Date</th>
                                                <th>Org</th>
                                                <th>Des</th>
                                                <th>Total</th>
                                                <th>Assigned</th>
                                                <th>Not-assigned</th>
                                                <th>Created_at</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Close_order_status;
